import { useEffect, useCallback } from 'react';
import { useAuthStore } from '../store/auth.store';
import { supabase } from '../lib/supabase';
import { 
  signInWithPassword as signInWithPasswordService,
  signInWithMagicLink as signInWithMagicLinkService,
  signOut as signOutService,
  resetPassword as resetPasswordService,
  isAdmin as isAdminCheck
} from '../lib/auth';

export const useAuth = () => {
  const { user, session, setSession, clearSession } = useAuthStore();

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setSession(session);
      }
    );

    return () => subscription.unsubscribe();
  }, [setSession]);

  const signIn = useCallback(async (email, password) => {
    const data = await signInWithPasswordService(email, password);
    setSession(data.session);
    return data;
  }, [setSession]);

  const signInWithMagicLink = useCallback(async (email) => {
    return signInWithMagicLinkService(email);
  }, []);

  const signOut = useCallback(async () => {
    await signOutService();
    clearSession();
  }, [clearSession]);

  const resetPassword = useCallback(async (email, redirectTo) => {
    return resetPasswordService(email, redirectTo);
  }, []);

  const isAuthenticated = !!session;
  const isAdmin = user ? isAdminCheck(user) : false;

  return {
    user,
    session,
    isAuthenticated,
    isAdmin,
    signIn,
    signInWithMagicLink,
    signOut,
    resetPassword,
    loading: false,
  };
};

export default useAuth;
